var exports = {
  "x": "xae11d333--6b0023--main-region",
  "R": "xae11d333--6b0023--clickable-text",
};

module.exports = exports;
